import React,{useState} from 'react';
import { FileSuccessIcon } from "../Icons/FileSuccessIcon";

interface UploadFileProps {
    handleUpload: (file: any) => void;
}
  
export const UploadFile: React.FC<UploadFileProps> = ({ handleUpload }) => {
    const [selectedFile, setSelectedFile] = useState<any | {}>({});


    const handleChange = (event: any) =>{
        setSelectedFile(event.target.files[0])
    }

    const handleSubmit = (event: any)=>{ 
        event.preventDefault();
        if(selectedFile === '') return;
        handleUpload(selectedFile)
    }

    return (
        <div className="ml-8 upload-btn-wrapper">
            <form action="submit" className="" onSubmit={handleSubmit}>
                <p className="text-18-500 mt-10 mb-4">Please upload Files</p>
                <button type='button' className="btn-upload">Choose files</button>
                <input type="file" name="myfile" className="cursor-pointer" onChange={handleChange} accept="application/json"/>
                <div className='mt-[20px]'>
                    {
                        selectedFile.name && (
                            <div>
                                <p className="text-18-500 mt-4 mb-4">Selected files:</p>
                                <div className="file-selected text-18-500 mb-4">
                                    <FileSuccessIcon /> {selectedFile.name}
                                </div>
                                <button className="btn-upload-submit mt-[20px]" disabled={(!selectedFile.name)}>Upload file</button>
                            </div>
                        )
                    }
                </div>
            </form>
        </div>
    )
}